/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamMediaSourceCurrent } from './oralExamMediaSourceCurrent';
import type { OralExamMediaSourceTotal } from './oralExamMediaSourceTotal';

/**
 * Per-source media-integrity view for the lecturer console.

Derived from the run's media-integrity intervals: `intact` is false while any
required source (camera/microphone/screen) is currently down; `current` lists
the live outages with their running duration; `totals` accumulates outage time
per source across the whole run for the audit/badge.
 */
export interface OralExamMediaIntegrity {
  intact?: boolean;
  current?: OralExamMediaSourceCurrent[];
  totals?: OralExamMediaSourceTotal[];
}
